<div class="single-image-section">
  <div class="container">
    <!-- One Unified Single Card - Full Width -->
    <article class="single-layout-card">
      <!-- Card Header / Title -->
      <div class="card-header-area" *ngIf="inputData?.TitleEn">
        <h1 class="card-title">{{ inputData.TitleEn }}</h1>
        <div class="card-title-divider"></div>
      </div>

      <!-- Full Width Image inside the Card -->
      <div class="card-image-wrap" *ngIf="inputData?.ShowAttachments && inputData.ShowAttachments.length > 0">
        <img 
          [src]="inputData.ShowAttachments[0].FilePath" 
          [alt]="inputData.ShowAttachments[0].Title || inputData.TitleEn || 'Featured Image'" 
          class="card-featured-img"
          loading="eager"
        />
        <div class="card-image-caption" *ngIf="inputData.ShowAttachments[0]?.Title && inputData.ShowAttachments[0].Title.trim() !== ''">
          <p>{{ inputData.ShowAttachments[0].Title }}</p>
        </div>
      </div>

      <!-- Card Body / Details Content -->
      <div class="card-body-area" *ngIf="inputData?.DetailsEn && inputData.DetailsEn.trim() !== ''">
        <div class="card-text-content" [innerHTML]="inputData.DetailsEn"></div>
      </div>
    </article>
  </div>
</div>